/**
 * Determines if a string contains only numbers.
 * @param {String} str string to validate
 * @returns true if it only contains numbers, otherwise false
 */
export const containsOnlyNumbers = (str) => {
    return /^\d+$/.test(str);
};
